import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";

const API_KEY = "AIzaSyARiIPpLjRTgJ8WL0i35I7TBzvVOE_ljFo";
const PAWS_PLAYLIST_ID = "PLKhK6FvDukHIl__7ms30kH1HPbWPy2GKk";
const BARD_PLAYLIST_ID = "PL3FhsetOK6fiOSS2Ay1sSJRWr2a0hxK90";

function Podcasts() {
  const [pawsVideos, setPawsVideos] = useState([]);
  const [bardVideos, setBardVideos] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    fetchVideos(PAWS_PLAYLIST_ID, setPawsVideos);
    fetchVideos(BARD_PLAYLIST_ID, setBardVideos);
  }, []);

  const fetchVideos = async (playlistId, setState) => {
    try {
      const res = await fetch(
        `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=50&playlistId=${playlistId}&key=${API_KEY}`
      );
      const data = await res.json();
      setState(data.items || []);
    } catch (err) {
      console.error("Failed to fetch videos", err);
    }
  };

  const filterVideos = (videos) => {
    return videos.filter((video) =>
      video.snippet.title.toLowerCase().includes(searchTerm.toLowerCase())
    );
  };

  return (
    <>
      <Header />
      <div className="min-h-screen p-8 bg-white">
        <button
          onClick={() => navigate("/home")}
          className="mb-6 inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 shadow-sm"
        >
          ← Back to Dashboard
        </button>

        <h1 className="text-3xl font-bold mb-6 text-gray-800">Podcast Library</h1>

        <input
          type="text"
          placeholder="Search episodes..."
          className="mb-8 w-full p-2 border border-gray-300 rounded shadow-sm"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

        <section className="mb-12">
          <h2 className="text-2xl font-semibold mb-4 text-blue-700">🎙️ Paws and Pawsitivity</h2>
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {filterVideos(pawsVideos).map((video) => (
              <div key={video.id} className="rounded overflow-hidden shadow hover:shadow-lg transition">
                <iframe
                  title={video.snippet.title}
                  width="100%"
                  height="200"
                  src={`https://www.youtube.com/embed/${video.snippet.resourceId.videoId}`}
                  frameBorder="0"
                  allowFullScreen
                />
                <div className="p-4">
                  <h3 className="text-sm font-medium text-gray-800">{video.snippet.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4 text-blue-700">🎤 The Barking Bard</h2>
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {filterVideos(bardVideos).map((video) => (
              <div key={video.id} className="rounded overflow-hidden shadow hover:shadow-lg transition">
                <iframe
                  title={video.snippet.title}
                  width="100%"
                  height="200"
                  src={`https://www.youtube.com/embed/${video.snippet.resourceId.videoId}`}
                  frameBorder="0"
                  allowFullScreen
                />
                <div className="p-4">
                  <h3 className="text-sm font-medium text-gray-800">{video.snippet.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
    </>
  );
}

export default Podcasts;
